import { render, staticRenderFns } from "./StepCommit.vue?vue&type=template&id=d52197e6&scoped=true&"
import script from "./StepCommit.vue?vue&type=script&lang=js&"
export * from "./StepCommit.vue?vue&type=script&lang=js&"
import style0 from "./StepCommit.vue?vue&type=style&index=0&id=d52197e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52197e6",
  null
  
)

export default component.exports